import PeriodicTable from "./element_table";

export const calcFormulaWeight = (atoms) => {
  let fw = 0.0;
  const pt = new PeriodicTable();

  for (let symbol of atoms.keys()) {
    const z = pt.symbolToNo(symbol);
    const a = atoms.get(symbol);
    fw += pt.getWeight(z) * a;
  }

  return fw;
};

export const calcAtomicCount = (atoms) => {
  let atomCount = 0;

  for (let symbol of atoms.keys()) {
    const a = atoms.get(symbol);
    atomCount += a;
  }

  return atomCount;
};
